import { render, staticRenderFns } from "./AgbFiliale.vue?vue&type=template&id=1cace488"
import script from "./AgbFiliale.vue?vue&type=script&lang=ts"
export * from "./AgbFiliale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports